module.exports = __webpack_public_path__ + "static/media/wind_dashboard_zh.b1e69add.png";